import { ServerDataSource } from "ng2-smart-table";
import { ServerSourceConf } from "ng2-smart-table/lib/data-source/server/server-source.conf";
import { getDeepFromObject } from "ng2-smart-table/lib/helpers";
import { Http, Headers, RequestOptions } from "@angular/http";
import { Router } from "@angular/router";
import { SessionStorageService } from "./session-storage.service";
import { RequestOptionsArgs } from "@angular/http/src/interfaces";

export class MyServerDataSourceService extends ServerDataSource {
  constructor(
    protected http: Http,
    conf: ServerSourceConf | {} = {},
    private session: SessionStorageService,
    private router: Router,
    private __params?: Object
  ) {
    super(http, conf);
  }

  public loading: boolean = true;
  public initialized: boolean = false;

  protected createRequestOptions(): RequestOptionsArgs {
    let requestOptions = super.createRequestOptions();
    requestOptions.headers = this.returnHeaders();
    requestOptions.params = this.returnParams(requestOptions);
    return requestOptions;
  }
  protected returnHeaders() {
    return new Headers({
      Authorization: "Bearer " + this.session.getToken(),
      user_id: this.session.getUserId(),
      group_id: this.session.getUserGroupId(),
    });
  }

  /**
   * returnParams
   *
   * Seta parametros extras para a busca
   *
   * @public
   * @author Elian Medeiros
   * @since  03/2018
   * @return {void}
   */

  protected returnParams(requestOptions: RequestOptionsArgs): URLSearchParams {
    if (this.__params) {
      let params: URLSearchParams;

      if (requestOptions.params)
        params = requestOptions.params as URLSearchParams;
      else params = new URLSearchParams();

      for (let key in this.__params) {
        params.set(key, this.__params[key]);
      }

      return params;
    } else {
      return requestOptions.params as URLSearchParams;
    }
  }

  myDelete(url) {
    return new Promise<any>((resolve, reject) => {
      let options = new RequestOptions({ headers: this.returnHeaders() });
      this.http
        .delete(url, options)
        .toPromise()
        .then((res) => {
          // pega a resposta
          const body = res.json();

          // Verifica se retornou um erro ou nao
          if (body.status) resolve(body.data);
          else reject(body.error);
        })
        .catch((error) => {
          const errorMsg = error.message
            ? error.message
            : error.status
            ? error.status + "-" + error.statusText
            : "Erro na requisição";

          if (error.status == 401 && this.router) {
            alert("Sessão encerrada");
            this.router.navigate(["auth"]);
          }

          reject(errorMsg);
        });
    });
  }

  protected requestItems() {
    return new Promise<any>((resolve, reject) => {
      this.loading = true;

      this.http
        .get(this.conf.endPoint, this.createRequestOptions())
        .toPromise()
        .then((res) => {
          this.lastRequestCount = this.extractTotalFromResponse(res);
          this.data = this.extractDataFromResponse(res);

          let formatter = this.extractFormatterFromResponse(res);

          //Se houver um formatador de dados
          if (formatter) {
            //Parcorre cada formatador
            for (let format in formatter) {
              //Percorre cada indice
              for (let i in this.data) {
                //Se na linha houver este item
                if (this.data[i][format])
                  //Recebe o valor do objeto ou devolve o dado normal
                  this.data[i][format] =
                    formatter[format][this.data[i][format]] ||
                    this.data[i][format];
              }
            }
          }

          this.loading = false;
          this.initialized = true;

          resolve(this.data);
        })
        .catch((erro) => {
          this.loading = false;
          this.initialized = true;

          if (erro.status == 401) {
            alert("Sessão encerrada.");
            this.session.clear();
            this.router.navigate(["auth"]);
          }

          this.lastRequestCount = 0;
          this.data = [];
          resolve(this.data);
        });
    });
  }

  getElements(): Promise<any> {
    return this.requestItems();
  }

  /**
   * Extrai formatadores de dados
   * @param res
   * @returns {any}
   */
  protected extractFormatterFromResponse(res: any): any {
    const rawData = res.json();
    return getDeepFromObject(rawData, "data.formatter", false);
  }
}



// WEBPACK FOOTER //
// ./src/services/my-server-data-source.service.ts